import React from 'react';

import { StyledBox, StyledLabel, StyledNativeInput } from './Checkbox.styles';
import { TCheckboxProps } from './Checkbox.types';

const Checkbox = ({ checked, onChange, label, disabled, className }: TCheckboxProps) => (
  <StyledLabel className={className}>
    <StyledNativeInput
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
    />
    <StyledBox checked={checked}>{checked ? '✓' : ''}</StyledBox>
    {label}
  </StyledLabel>
);

export default Checkbox;
